import * as React from 'react';
import { useTranslation } from 'react-i18next';
import css from './FfpInfoStatusesMaxLevel.css';

const FfpInfo: React.FC = () => {
	const { t } = useTranslation('Loyalty');

	return (
		<div className={css.block}>
			<div className={css.title}>{t('Congratulations!')}</div>
			<div className={css.title}>{t('You have reached the final top level!')}</div>
		</div>
	);
};
export default FfpInfo;
